import React from "react";

const AlgoStatusCell: React.FC<{
  value: string | null | undefined;
}> = React.memo(({ value }) => {
  const getStatusColor = () => {
    if (value) {
      switch (value.toLowerCase()) {
        case "running":
          return "#46da70"; // green
        case "stopped":
          return "#fe3c46"; // red
        case "stopping":
          return "#fc9749"; // orange
        case "resuming":
          return "#79a5ef"; // blue
        default:
          return "#939db6"; // gray
      }
    }
    return "#b6bdce"; // default gray
  };

  return (
    <div
      style={{
        backgroundColor: getStatusColor(),
        color: "#0c1835",
        padding: "4px 8px",
        borderRadius: "4px",
        textAlign: "center",
        fontWeight: 600,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {value}
    </div>
  );
});

export default AlgoStatusCell;
